import { Typography } from "@mui/material";
import { StyledButton } from "customStyled";
import { SelectIcon } from "components/icon";

const CopyButton = ({
  disabled = false,
  label = null,
  copyText = "copy text",
  icon = "",
  clickEvent = null,
}) => {
  return (
    <StyledButton
      variant="text"
      disabled={disabled}
      onClick={clickEvent}
      sx={{ color: "#000", alignSelf: "flex-start" }}
      startIcon={<SelectIcon value={icon} selected={false} />}
    >
      {label ? <Typography>{label}</Typography> : null}
    </StyledButton>
  );
};

export default CopyButton;
